export function getIsNative(userAgent) {
  return (
    // Original regex check for webview to determine that we are in native.
    /((iPhone|iPod|iPad).*AppleWebKit(?!.*Version)|; wv)/i.test(userAgent) &&
    /**
     * In iOS, third-party browsers such as Chrome are technically embedded
     * in a webview, and detected as such. So we will specifically check
     * for these to ensure that we are not mistaking them for native.
     * See: https://stackoverflow.com/a/52125247
     */
    !/CriOS/.test(userAgent) &&
    !/FxiOS/.test(userAgent) &&
    !/OPiOS/.test(userAgent)
  );
}
